import React from "react";
import {
  ScreenFlow,
  RecruitmentSteps,
} from "../../components";

const flowarray = [
  { title: "Home", link: "/" },
  { title: "Find Trials", link: "/#find_trial" },
  {
    title: "Search Results",
    link: `/results?q=NCT04956575&in=UNITED%20STATES`,
  },
  {
    title: "Trial Details",
    link: `/study/NCT04956575`,
  },
];

class NCT04956575 extends React.Component {
  
  render() {
    return (
      <div>
        {this.props.location &&
        this.props.location.search &&
        this.props.location.search.indexOf("embed=true") !== -1 ? null : (
          <>
            <RecruitmentSteps step={"Review Trials"} />
            <div className="container px-2 d-flex align-items-center justify-content-start">
              <ScreenFlow flow={flowarray} />
            </div>
          </>
        )}
        <div className="container px-2">
          <iframe style={{height:2400,width:'100%',border:'none'}} title="NCT04956575" src="https://connect.trialscope.com/studies/676cff1f-102b-4273-80f0-a57716b9c81b?embed=1"></iframe>
        </div>
      </div>
    );
  }
}

export default NCT04956575;
